import React from 'react'
import ORGANISATION_TYPES from '../../utils/constants/OrganisationTypes'
import { useCmsScope } from '../../context/useCmsScope'
import CmsAdminPageFederation from './CmsAdminPageFederation'
import CmsAdminPageCompetition from './CmsAdminPageCompetition'

const CmsAdminPage = () => {
  const { orgType } = useCmsScope()

  if (orgType === ORGANISATION_TYPES.ORG_COMPETITION) {
    return <CmsAdminPageCompetition />
  }

  return <CmsAdminPageFederation />
}

export default CmsAdminPage
